import clsx from "clsx";
import { PropsWithChildren } from "react";
import styles from "./Center.module.scss";

type CenterProps = PropsWithChildren<{
  className?: string;
}>;

const Center = ({ className, children }: CenterProps) => {
  return <div className={clsx(styles.center, className)}>{children}</div>;
};

export default Center;
